import { normalizeId } from "../utils";

export const projectCommentsKeys = {
  all: ["project-comments"] as const,

  comments: (
    projectId: string | number,
    documentId: string | number,
    filters?: { status?: "open" | "resolved" }
  ) =>
    [
      ...projectCommentsKeys.all,
      "comments",
      normalizeId(projectId),
      normalizeId(documentId),
      filters?.status ?? null,
    ] as const,

  commentsDocumentScope: (projectId: string | number, documentId: string | number) =>
    [
      ...projectCommentsKeys.all,
      "comments",
      normalizeId(projectId),
      normalizeId(documentId),
    ] as const,

  shell: (projectId: string | number, documentId: string | number) =>
    [...projectCommentsKeys.all, "shell", normalizeId(projectId), normalizeId(documentId)] as const,
};
